import React from "react";

const AboutHome = () => {
  return (
    <section>
      <div className="support about-hero">
        <div className="container">
          <div className="about-hero-text text-light d-flex justify-content-center py-5">
            <h1 className="fw-bold">About Us</h1>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutHome;
